import { render, staticRenderFns } from "./macetas-de-plastico-cultivo.vue?vue&type=template&id=664931ef&lang=html"
import script from "./macetas-de-plastico-cultivo.vue?vue&type=script&lang=js"
export * from "./macetas-de-plastico-cultivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports